/**
 * Sugestão do NOME do envio (req 1). O padrão da casa é `FICC-NNN` com um número
 * sequencial. `suggestNextPlanName` varre os planos existentes, acha o maior N já
 * usado no padrão FICC e sugere o próximo (`FICC-<max+1>`, com 3 dígitos),
 * orientando o operador a seguir a sequência correta. Sem React/DOM — testável.
 */
const FICC_NAME_RE = /^FICC[-\s]?0*(\d+)/i;

/** Prefixo + dígitos usados na sugestão (também o placeholder do campo). */
export const PLAN_NAME_PREFIX = "FICC-";
export const PLAN_NAME_PAD = 3;

export function suggestNextPlanName(
  plans: readonly { name: string | null }[]
): string {
  let max = 0;
  for (const plan of plans) {
    const match = (plan.name ?? "").trim().match(FICC_NAME_RE);
    if (match) {
      const n = Number(match[1]);
      if (Number.isFinite(n) && n > max) {
        max = n;
      }
    }
  }
  return `${PLAN_NAME_PREFIX}${String(max + 1).padStart(PLAN_NAME_PAD, "0")}`;
}
